import { apiClient } from "./apiClient";
import UserProfile from "../types/UserProfile";

export const updateProfile = async (
  profileData: Partial<UserProfile>,
): Promise<UserProfile> => {
  let url_prefix = "https://roger-that-e17b66fe09c9.herokuapp.com/";
  if (process.env.NODE_ENV === "development") {
    url_prefix = "http://127.0.0.1:8000/";
  }

  var url = url_prefix + "apiapp/users/me/";

  // Convert frontend field names to backend field names
  const backendData: any = {};
  if (profileData.firstName !== undefined)
    backendData.first_name = profileData.firstName;
  if (profileData.lastName !== undefined)
    backendData.last_name = profileData.lastName;
  if (profileData.dateOfBirth !== undefined) {
    backendData.date_of_birth =
      profileData.dateOfBirth === "" ? null : profileData.dateOfBirth;
  }
  if (profileData.phoneNumber !== undefined)
    backendData.phone_number = profileData.phoneNumber;
  if (profileData.username !== undefined)
    backendData.username = profileData.username;
  if (profileData.userType !== undefined)
    backendData.user_type = profileData.userType;
  if (profileData.otherSoftware !== undefined)
    backendData.other_software = profileData.otherSoftware;
  if (profileData.experience !== undefined)
    backendData.experience = profileData.experience;
  if (profileData.feedback !== undefined)
    backendData.feedback = profileData.feedback;
  if (profileData.reminderEmail !== undefined)
    backendData.reminder_email = profileData.reminderEmail;
  if (profileData.reminderBrowser !== undefined)
    backendData.reminder_browser = profileData.reminderBrowser;

  // Note: email is intentionally excluded from updates

  const responseData = await apiClient(url, backendData, "PATCH");

  if (!responseData) {
    throw new Error("Failed to update profile");
  }

  return {
    id: responseData.id,
    firstName: responseData.first_name || "",
    lastName: responseData.last_name || "",
    dateOfBirth: responseData.date_of_birth || "",
    email: responseData.email || "",
    phoneNumber: responseData.phone_number || "",
    username: responseData.username || "",
    userType: responseData.user_type || "",
    otherSoftware: responseData.other_software || "",
    experience: responseData.experience || "",
    feedback: responseData.feedback || "",
    reminderEmail: responseData.reminder_email,
    reminderBrowser: responseData.reminder_browser,
    highScore: responseData.high_score,
    completedSurvey: responseData.completed_survey,
    practiceCount: responseData.practice_count,
  };
};
